import { render } from "./ListAuthorizationsView.vue?vue&type=template&id=ec7b4340&scoped=true&ts=true"
import script from "./ListAuthorizationsView.vue?vue&type=script&lang=ts"
export * from "./ListAuthorizationsView.vue?vue&type=script&lang=ts"

import "./ListAuthorizationsView.vue?vue&type=style&index=0&id=ec7b4340&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec7b4340"]])

export default __exports__